import { bool, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { Pencil } from "@assets";
import useStyle from "./Tooltip.style";
import { offset, useClientPoint, useFloating, useInteractions } from "@floating-ui/react";
import { Grid, Portal } from "@material-ui/core";
import { EDITOR_CONTAINER_ID } from "@utils";
import classnames from "classnames";
import { APP_BAR_HEIGHTS } from "@styles/themes";

export const Tooltip = ({ show, elementClass }) => {
  const { t } = useTranslation();
  const classes = useStyle();

  // const elClass = anchor ? anchor.elClass : "";
  // const anchor = useRef(document.body);
  
  const {refs, floatingStyles, context} = useFloating({
    placement: "right",
    middleware: [
      offset(10),
    ],
    elements: {
      reference: document.getElementById(EDITOR_CONTAINER_ID),
    }
  });
  
  const clientPoint = useClientPoint(context);
  
  const { getFloatingProps } = useInteractions([ clientPoint ]);
  
  if(!elementClass || !show)
    return null;
  
  return (
    <Portal>
      <div
        ref={refs.setFloating}
        style={floatingStyles}
        className={classnames(
          classes.root,
          floatingStyles?.transform?.match(/, (\d+)px/)?.[1] < APP_BAR_HEIGHTS.LARGE*3 && "hidden"
        )}
        role="presentation"
        {...getFloatingProps()}
      >
        <Grid item container alignItems="center" className={classes.content}>
          <Pencil className="mr-1" />
          {t(`views.editor.preset.edit_tags.${elementClass}`)}
        </Grid>
      </div>
    </Portal>
  )
};

Tooltip.propTypes = {
  show: bool,
  elementClass: string,
};
